import React, { useState } from 'react'
import { useParams, useLocation } from "react-router-dom"
import "./ChartsPage.css"
import { useChartsData } from '../hooks/useChartsData'
import { useCompareCharts } from '../hooks/useCompareCharts'
import { useWorldData } from '../hooks/useWorldData'
import { useIndicatorNavigation } from '../hooks/useIndicatorNavigation'
import { buildCountryMap } from '../utils/countryMap'
import IndicatorTabs from '../components/charts/IndicatorTabs/IndicatorTabs'
import IndicatorInfoPanel from '../components/charts/IndicatorInfoPanel'
import SummaryPanel from '../components/charts/SummaryPanel'


const ChartsPage = ({ compareMode, compareCountries }) => {
  const { code } = useParams()
  const location = useLocation()
  const { indicators_groups, indicators_map, permissions } = useChartsData(code)

  const [activeTab, setActiveTab] = useState(null)
  const [selectedIndicator, setSelectedIndicator] = useState(null)

  const { countries } = useWorldData()
  const countryMap = buildCountryMap(countries)

  const canDownloadCharts = permissions?.download_charts ?? false

  console.log('indicator data', indicators_map, indicators_groups)

  // Single source of truth for navigation-stack / carousel-level state.
  // Shared by IndicatorTabs (renders the level) and IndicatorInfoPanel
  // (drives "Related" / back buttons), so the two can never drift apart.
  const nav = useIndicatorNavigation(
    indicators_groups,
    activeTab,
    indicators_map,
    code,
    compareMode,
    compareCountries,
  )

  const selectedGroup = indicators_groups?.find(
    g => g.name === activeTab
  )

  const activeGroupSummary = selectedGroup && indicators_map?.[`${selectedGroup.id}_summary`]?.meta?.description

  const countryName = location.state?.countryName || code

  const safeCompareCountries = Array.isArray(compareCountries)
    ? compareCountries
    : []
  const compareData = useCompareCharts(safeCompareCountries)

  return (
    <div className="charts-page">
      <h2 className="page-title">{countryName}</h2>

      <div className="charts-page-body">
        {/* Tabs */}
        <div className="charts-page-tabs">
          <IndicatorTabs
            indicators_groups={indicators_groups}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            onIndicatorChange={setSelectedIndicator}
            countryMap={countryMap}
            currentCode={code}
            compareMode={compareMode}
            compareCountries={compareCountries}
            compareData={compareData}
            nav={nav}
            canDownload={canDownloadCharts}
          />
        </div>

        {/* Info Panel */}
        <div className="charts-page-info">
          <IndicatorInfoPanel
            sources={selectedIndicator?.meta?.sources}
            navigationStack={nav.navigationStack}
            selectedIndicator={selectedIndicator}
            onNavigateBack={nav.navigateBack}
            onNavigateToChildren={() => nav.navigateToChildren(selectedIndicator)}
          />
        </div>
      </div>

      <SummaryPanel
        summary={activeGroupSummary}
      />
    </div>
  )
}

export default ChartsPage
